import { render, staticRenderFns } from "./IcoFireAi.vue?vue&type=template&id=5fa73e2d"
import script from "./IcoFireAi.vue?vue&type=script&lang=js"
export * from "./IcoFireAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports